
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useRecoilState, useRecoilValue } from 'recoil';
import { tempState } from '../../atom/atom';

const FilterComponent = ({ columns, data, onFilter }) => {
  const [selectedColumn, setSelectedColumn] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const [uniqueValues, setUniqueValues] = useState([]);
  const [temp, setTemp] = useRecoilState(tempState)


  useEffect(() => {
    setTemp(filterValue)
  }, [filterValue])

  // Function to get unique values based on the column selected
  const getUniqueValues = (column) => {
    if (!column) return [];
    const columnConfig = columns.find((col) => col.name === column);

    if (columnConfig?.getValues) {
      console.log('ffdfdfdfd', data);
      return columnConfig.getValues(data);




    } else if (Array.isArray(data) && columnConfig?.selector) {
      console.log('ff', data);

      const values = data.map((row) => columnConfig?.selector(row));
      console.log("nnn", [...new Set(values)].filter((value) => value !== undefined && value !== null));

      return [...new Set(values)].filter((value) => value !== undefined && value !== null);
    }
    return [];
  };






  useEffect(() => {
    console.log("dfghj");

    if (selectedColumn) {
      console.log('selected', selectedColumn);

      const uniqueVals = getUniqueValues(selectedColumn);
      setUniqueValues(uniqueVals);
    } else {
      console.log('selected2', selectedColumn);

      setUniqueValues([]); // Clear unique values when no column is selected
    }
  }, [selectedColumn, data]);

  // Handle column selection
  const handleColumnChange = (columnName) => {
    console.log("sdfghjk");
    if (columnName != selectedColumn && columnName) {
      console.log("ifff", columnName);
      setSelectedColumn(columnName);
      setFilterValue(''); // Clear filter value when column changes
      setUniqueValues([]); // Clear unique values until the new column's data is fetched
    }

  };

  // Handle filter value change
  const handleValueChange = (value) => {
    setFilterValue(value);
  };

  const applyFilter = (e) => {
    e.preventDefault();

    if (selectedColumn && filterValue) {
      const columnConfig = columns?.find((col) => col.name === selectedColumn);

      const filteredData = data?.filter((row) => {
        const value = columnConfig?.selector(row);

        // Special case for filtering `Days`
        if (selectedColumn === "Day") {
          if (Array.isArray(row.Days)) {
            return row.Days.includes(filterValue); // Check if filterValue matches any day
          }
          return false;
        }

        // General string or number-based filtering
        if (typeof value === "string") {
          return value.toLowerCase() === filterValue.toLowerCase();
        } else if (typeof value === "number") {
          return value === Number(filterValue); // Match only exact numbers
        }
        return false;
      });

      onFilter(filteredData, { column: selectedColumn, value: filterValue });
    }
  };


  // const applyFilter = (e) => {
  //   e.preventDefault();

  //   if (selectedColumn && filterValue) {
  //     console.log('sol3');
  //     const columnConfig = columns.find((col) => col.name === selectedColumn);

  //     const filteredData = data?.filter((row) => {
  //       const value = columnConfig.selector(row);

  //       // Special case for filtering `Days`
  //       if (selectedColumn === "Day") {
  //         console.log('sol2');
  //         if (Array.isArray(row.Days)) {
  //           return row.Days.includes(filterValue); // Check if filterValue matches any day
  //         }
  //         return false;
  //       }

  //       // General string or number-based filtering
  //       if (typeof value === "string") {
  //         console.log('sol1');

  //         return value.toLowerCase().includes(filterValue.toLowerCase());
  //       } else if (typeof value === "number") {
  //         return value.toString().includes(filterValue);
  //       }
  //       return false;
  //     });

  //     onFilter(filteredData,{ column: selectedColumn, value: filterValue });
  //     console.log('filltrerddata',filteredData);

  //   }
  // };


  // const customStyles = {
  //   menu: (provided) => ({
  //     ...provided,
  //     maxHeight: '130px', // Set the maximum height for the dropdown menu
  //     overflowY: 'auto',  // Add vertical scrolling
  //   }),
  // };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '130px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '130px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555'
      }
    })
  };

  const handleClearFilter = () => {
    setSelectedColumn('');
    setFilterValue('');
    setUniqueValues([]);
    onFilter(data); // Reset to original data
  };
  const excluded = ['Action', 'Sl No', 'Dates', 'Day', 'Mobile', 'Email', 'No of Allocations', 'Status'];

  const columnOptions = columns
    ?.filter(col =>
      typeof col.name === 'string' && // Ensure col.name is a string
      !excluded.includes(col.name) &&
      !col.name.toLowerCase().includes('time')
    )
    ?.map(col => ({
      value: col.name,
      label: col.name,
    }));

  console.log(columnOptions);


  const valueOptions = uniqueValues
    .filter(value => value !== "")
    .map(value => ({
      value: value,
      label: value,
    }));


  return (
    <div className="flex items-center py-4 gap-4">
      <Select
        value={selectedColumn ? columnOptions.find((option) => option.value === selectedColumn) : null}
        onChange={(selectedOption) => handleColumnChange(selectedOption.value)}
        options={columnOptions}
        placeholder="Select Column"
        className="w-1/4 border rounded-md shadow-sm h-[30px]"
      />

      {selectedColumn && (
        <>
          <Select
            value={filterValue ? valueOptions.find((option) => option.value === filterValue) : null}
            onChange={(selectedOption) => handleValueChange(selectedOption.value)}
            options={valueOptions}
            placeholder="Select Value"
            className="w-1/4 border rounded-md mt-3 shadow-sm"
            styles={customStyles}
          // isSearchable={false}
          />
          <button onClick={applyFilter} className="btn mt-3  btn-success">
            Apply Filter
          </button>
          <button onClick={handleClearFilter} className="btn mt-3  btn-outline-secondary">
            Clear Filter
          </button>
        </>
      )}
    </div>
  );
};

export default FilterComponent;

